import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"
import type {
    OperationLogListResponse,
    UserItem,
    UserListResponse,
    UserOptionListResponse,
    UserPermissionsResponse,
} from "./types"

// 取得 users
export function getUsers(config: AxiosRequestConfig = {}) {
    return instance.request<UserListResponse>({
        url: "/accounts/users/",
        method: "get",
        ...config,
    })
}

// 取得 users 列表
export function getUserOptions(config: AxiosRequestConfig = {}) {
    return instance.request<UserOptionListResponse>({
        url: "/accounts/users-options/",
        method: "get",
        ...config,
    })
}

// 取得單個 user
export function getUser(userId: string, config: AxiosRequestConfig = {}) {
    return instance.request<UserItem>({
        url: `/accounts/users/${userId}/`,
        method: "get",
        ...config,
    })
}

// 新增 user
export function createUser(config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: "/accounts/users/",
        method: "post",
        ...config,
    })
}

// 更新 user
export function updateUser(userId: string, config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: `/accounts/users/${userId}/`,
        method: "patch",
        data: config.data,
        ...config,
    })
}

// 啟用 user
export function setUserActive(userId: string, config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: `/accounts/users/${userId}/activate/`,
        method: "post",
        ...config,
    })
}

// 停用 user
export function setUserInactive(
    userId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/accounts/users/${userId}/inactivate/`,
        method: "post",
        ...config,
    })
}

// 刪除 user
export function deleteUser(userId: string, config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: `/accounts/users/${userId}/`,
        method: "delete",
        ...config,
    })
}

// 取得 user 權限
export function getUserPermissions(
    userId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<UserPermissionsResponse>({
        url: `/accounts/users/${userId}/permissions/`,
        method: "get",
        ...config,
    })
}

// 更新 user 權限
export function updateUserPermissions(
    userId: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request<void>({
        url: `/accounts/users/${userId}/permissions/`,
        method: "patch",
        ...config,
    })
}

// 發送 user 啟用信件
export function sendUserEmail(userId: string, config: AxiosRequestConfig = {}) {
    return instance.request<void>({
        url: `/accounts/users/${userId}/resend-invite/`,
        method: "post",
        ...config,
    })
}

// 取得操作歷程列表
export function getOperationHistory(config: AxiosRequestConfig = {}) {
    return instance.request<OperationLogListResponse>({
        url: `/accounts/users/operation-logs/`,
        method: "get",
        ...config,
    })
}
